module.exports = "<react-getting-started></react-getting-started>";